import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetStats = {
  getStats: { data: null, loading: false, error: null },
};

export const getStats = createAsyncThunk('user/getStats', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/vacancies/categories`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetStats = {
  [getStats.pending]: (state) => {
    state.getStats.loading = true;
    state.getStats.error = null;
  },
  [getStats.fulfilled]: (state, action) => {
    state.getStats.loading = false;
    state.getStats.data = action.payload;
    state.getStats.error = null;
  },
  [getStats.rejected]: (state, action) => {
    state.getStats.loading = false;
    state.getStats.error = action.payload;
  },
};
